import { useMutation, useQueryClient } from '@tanstack/react-query';

import { quizzesQueryKey } from '~teacher/hook';

import { copyWorkspaceQuizToPersonal } from '../../../api/workspaces/copyWorkspaceQuizToPersonal';

export function useCopyWorkspaceQuizToPersonal() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: copyWorkspaceQuizToPersonal,
    onSuccess: () => {
      return queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
  });
}
